export enum ChangeRequestType {
  ADDITION = "ADDITION",
  REMOVAL = "REMOVAL",
  EDIT = "EDIT",
}

export enum ChangeRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum EmployeeStatus {
  ACTIVE = "active",
  PENDING_APPROVAL = "pending_approval",
  PENDING_REMOVAL = "pending_removal",
  REMOVED = "removed",
  REJECTED = "rejected",
  QUERIED = "queried"
}
